module.exports = __webpack_public_path__ + "media/images/home/hero_widget_mobile_bg_old1-619455671de5ff6ca8d1d011b5ba342e.png";